<template>
  <div
      @click="checkHeight"
      @touchstart="checkHeight"
      @wheel="checkHeight"
      :class="['card-icon-title-container',
      nameClass,
      ]">
    <icon-default :size="'big'"
                  :icon="item.icon"
    />
    <sub-title class="main-title-container">
      {{ item.title }}
    </sub-title>
    <div class="card-icon-title-content">
      <main-paragraph :weight="'bold'"
                      :font-family="'Verdana'"
                      :color="'purple-grey'">
        {{ item.mainText }}
      </main-paragraph>
      <main-paragraph :color="'purple-grey'"
                      class="main-text-container"
                      :line-height="'big'"
                      :font-family="'Verdana'">
        {{ item.text }}
      </main-paragraph>
    </div>
  </div>
</template>

<script>
import IconDefault from "@/components/shared/IconDefault.vue";
import SubTitle from "@/components/shared/text/SubTitle.vue";
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import {mapActions} from "vuex";

export default {
  name: "CardIconTitleInfo",
  components: {MainParagraph, SubTitle, IconDefault},
  props: {
    idActive: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      required: true
    },
    isActiveGradient: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    nameClass() {
      return `card-icon-title-container-${this.item.id}`
    },
  },
  methods: {
    ...mapActions(['BLOCK_SCROLL_GLOBAL']),
    blockSlider() {
      if(this.isActiveGradient && !this.$isMobile) {
        this.BLOCK_SCROLL_GLOBAL(true)
      }
    },
    checkHeight() {
      if(this.isActiveGradient && !this.$isMobile) {
        let block = document.querySelector(`.${this.nameClass}`);
        if(block) {
          block.scrollTop = 0;
        }
        this.$emit('setActiveHeight')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card-icon-title-container {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    display: none;
  }

  .card-icon-title-content {
    display: flex;
    flex-direction: column;
  }

  .main-text-container {
    white-space: pre-wrap;
  }
}


@media (max-width: 3024px){
  .card-icon-title-container {
    row-gap: 16px;
    .icon-container {
      margin-bottom: 6px;
    }
    .card-icon-title-content {
      row-gap: 16px;

      .text-content {
        font-size: 18px;
      }
    }
    .main-title-container {
      min-height: 58px;
      height: 0;
    }
  }
}


@media (max-width: 1920px) {
  .card-icon-title-container {
    row-gap: 16px;
    .icon-container {
      margin-bottom: 6px;
    }
    .card-icon-title-content {
      row-gap: 16px;

      .text-content {
        font-size: 16px;
      }
    }
    .main-title-container {
      min-height: 48px;
      height: 0;
    }
  }
}


@media (max-width: 1600px) {
  .card-icon-title-container {
    row-gap: 16px;
    .icon-container {
      margin-bottom: 6px;
    }
    .card-icon-title-content {
      row-gap: 16px;

      .text-content {
        font-size: 12px;
      }
    }
    .main-title-container {
      min-height: 48px;
      height: 0;
    }
  }
}
@media (max-height: 800px) {
  .card-icon-title-container {
    row-gap: 16px;
    .icon-container {
      margin-bottom: 6px;
    }
    .card-icon-title-content {
      row-gap: 16px;

      .text-content {
        font-size: 12px;
      }
    }
    .main-title-container {
      min-height: 34px;
      height: 0;
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .card-icon-title-container {
    row-gap: 16px;
    .icon-container {
      margin-bottom: 6px;
    }
    .card-icon-title-content {
      row-gap: 16px;

      .text-content {
        font-size: 12px;
      }
    }
    .main-title-container {
      min-height: 48px;
      height: 0;
    }
  }
}

@media (max-width: 1133px) {
  .card-icon-title-container {
    row-gap: 16px;

    .icon-container {
      margin-bottom: 6px;
    }
    .card-icon-title-content {
      row-gap: 16px;

      .text-content {
        font-size: 12px;
      }
    }
    .main-title-container {
      min-height: 34px;
      height: 0;
    }
  }
}

@media (max-width: 769px) {
  .card-icon-title-container {
    row-gap: 16px;
    height: fit-content;

    .icon-container {
      margin-bottom: 6px;
    }
    .card-icon-title-content {
      row-gap: 16px;

      .text-content {
        font-size: 12px;
      }
    }
    .main-title-container {
      min-height: 34px;
      height: 0;
    }
  }
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //plus
}

@media (min-height: 600px) and (max-height: 630px){

  //8 plus
}

@media (max-width: 375px) {
  //se new
}

@media (max-width: 375px) and (min-height: 630px) {
  //x
}


@media (max-width: 320px) {
  //se old
}

@media (min-width: 3025px) {
  .card-icon-title-container {
    row-gap: 24px;
    .icon-container {
      margin-bottom: 16px;
    }
    .card-icon-title-content {
      row-gap: 24px;

      .text-content {
        font-size: 30px;
      }
    }
    .main-title-container {
      min-height: 100px;
      height: 0;
    }
  }
}



</style>